module.exports = __webpack_public_path__ + "2ebbb23420d9eb28434beb45704a89e8.png";